import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  inject,
  Input,
  Output,
} from '@angular/core';
import { ThemeService } from 'src/app/core/services/theme/theme.service';
import { CurrencyAmountDisplay } from 'src/app/core/services/currency/currency-format';
import { GameInterfaceState } from '../../game/controllers/listeners-legacy/ux-game-listener';
import { GameId } from 'src/app/model/game/game-id';
import { TranslocoService, TranslocoDirective } from '@jsverse/transloco';
import { ThemePipe } from '../../../core/pipes/theme.pipe';
import { CurrencyIconComponent } from '../../../ui/currency-icon/currency-icon.component';
import { NgStyle } from '@angular/common';
import { NavButtonComponent } from '../../../ui/buttons/nav-button/nav-button.component';

@Component({
  selector: 'app-game-replay',
  templateUrl: './game-replay.component.html',
  styleUrls: ['./game-replay.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslocoDirective, NavButtonComponent, NgStyle, CurrencyIconComponent, ThemePipe],
})
export class GameReplayComponent {
  @Input({ required: true }) gameId!: GameId;
  @Input({ required: true }) gameInterfaceState!: GameInterfaceState;
  @Input() reward?: { primary: CurrencyAmountDisplay; secondary: CurrencyAmountDisplay };
  @Input() roomId?: string;

  @Output() closeClicked = new EventEmitter<void>();

  private translocoService = inject(TranslocoService);
  themeService = inject(ThemeService);

  GameInterfaceState = GameInterfaceState;

  readonly prizeStyles: [string, string][] = [
    ['text-color', 'replay-header-prize'],
    ['type', 'replay-header-prize'],
  ];

  readonly scorePillStyles: [string, string][] = [
    ['background', 'pill-score'],
    ['border-radius', 'pill-score'],
    ['text-color', 'pill-score-label'],
    ['type', 'pill-score-label'],
  ];

  readonly roomStyles: [string, string][] = [
    ['text-color', 'replay-header-matchid'],
    ['type', 'replay-header-matchid'],
  ];

  get hasSecondaryCurrency(): boolean {
    return this.themeService.hasSecondaryCurrency;
  }

  onCloseClicked() {
    this.closeClicked.emit();
  }
}
